export enum FeatureType {
  Navaid = 0,
  CoordinatePoint = 1,
  Procedure = 2,
  RouteSegments = 3,
  Annotation = 4,
  AirSpaceBoundary = 5,
  AzimuthTool = 6,
  RangeRingTool = 7,
	HorizonTool = 8,
	Trajectory = 9,
  ProcedureGraph = 10,
  DbBoundary = 11,
  SAAMTraffic = 12,
  CrossSection = 13,
  InertialDrift = 14,
  FlightInspection = 15,
  ProcessingTool = 16,
  CumulativeCoverage = 17,
  PerformanceAvailablePairs = 18,

  //#region GRIT
  Device = "RFI-Transmitter",
  Receiver = "Receiver",
  InterferenceTest = "Interference Test",
  Radar = "Radar",
  //endregion

}
export enum NavaidFileType{
  flightInspectionReport="flightInspectionReport",
  antennaDiagram="antennaDiagram",
  vorFlightInspectionReports="vorFlightInspectionReports"
}

export const NavaidStatus = {
  OPERATIONAL: { value: "OPERATIONAL", html: "Operational" },
  PLANNED: { value: "PLANNED", html: "Planned" },
  DECOMMISSIONED: { value: "DECOMMISSIONED", html: "Decommissioned" },
  OUT_OF_SERVICE: { value: "OUT_OF_SERVICE", html: "Out of Service Temporarily" }
} as const;


export enum MapSearchCoordPointsFields {
  coordpointid = "Id",
  name = "Name",
  type = "Type",
  latitude = "Latitude",
  longitude = "Longitude",
  userdefined = "User Defined",
  maxaltitude = "Max Altitude",
  minaltitude = "Min Altitude",
  nominalaltitude = "Nominal Altitude"
}

export function getMapSearchCoordPointsFieldsKeyByValue(value: string) {
  const indexOfS = Object.values(MapSearchCoordPointsFields).indexOf(value as unknown as MapSearchCoordPointsFields);

  const key = Object.keys(MapSearchCoordPointsFields)[indexOfS];

  return key;
}

export function getMapSearchNavAidsFieldsKeyByValue(value: string) {
  const indexOfS = Object.values(MapSearchNavAidsFields).indexOf(value as unknown as MapSearchNavAidsFields);

  const key = Object.keys(MapSearchNavAidsFields)[indexOfS];

  return key;
}

export enum MapSearchNavAidsFields {
  navaidid = "Id",
  name = "Name",
  navaidtype = "Type",
  latitude = "Latitude",
  longitude = "Longitude",
  elevation = "Elevation",
  doc = "DOC",
  userdefined = "User Defined",
  maxaltitude = "Max Altitude",
  icaocc = "ICAO Country Code",
  channel = "Channel"
}

export enum PropagationType {
  LineOfSight = "Line of sight",
  DiffractionKEM = "Diffraction (Knife-Edge model)",
  Diffraction60S = "Diffraction (60% Simplification)"
}

export enum RangeLimitation{
  DOC = "DOC",
  RadioHorizon = "Radio Horizon",
  FOM = "FOM",
  FSPL = "FSPL"
}

export enum CalculationType{
  Coverage = "Coverage",
  CumulativeCoverage = "Cumulative Coverage"
}

export enum CoverageAlgorithmType{
  Screening = "Screening",
  Visibility = "Visibility"
}

export enum NavaidTypes{
  DME = "DME",
  VOR_DME = "VOR_DME",
  TACAN = "TACAN",
  VORTAC = "VORTAC",
  DME_ILS = "DME_ILS",
  NDB = "NDB",
  VOR = "VOR"
}
export enum UserLayerTypes{
  KML="KML",
  SHAPEFILE="SHAPEFILE"
}
export function getNavaidTypesKeyByValue(value: string) {
  const indexOfS = Object.values(NavaidTypes).indexOf(value as unknown as NavaidTypes);

  const key = Object.keys(NavaidTypes)[indexOfS];

  return key;
}

export enum CoordinatePointTypes{
  WAYPOINT = "WAYPOINT",
  ARP_CIVIL = "ARP CIVIL",
  ARP_MILITAR = "ARP MILITARY",
  RWY_THR = "RWY THR",
  AIRSPACE_BOUNDARY_VERTEX = "AIRSPACE BOUNDARY VERTEX",
  ARP_MIXED = "ARP MIXED",
  FIX_POINT = "FIX POINT",
  TRAJECTORY = "TRAJECTORY"
}

export function getCoordinatePointTypesKeyByValue(value: string) {
  const indexOfS = Object.values(CoordinatePointTypes).indexOf(value as unknown as CoordinatePointTypes);

  const key = Object.keys(CoordinatePointTypes)[indexOfS];

  return key;
}

export enum AnnotationType {
  LineString = "LineString",
  Polygon = "Polygon",
  Circle = "Circle",
  Freehand = "Freehand",
  Text = "Text"
}
export enum ShapeType {
  Circle = 'circle',
  Square = 'square',
  Rectangle = 'rectangle',
  Triangle = 'triangle',
  Star = 'star',
  Cross = 'cross',
  X = 'x',
}
export enum ProcCoordPointTypeEnum {
	NONE = "",
//	Fly-Over F/O
	F_O = "Fly-Over",
//	Fly-By F/B
	F_B = "Fly-By",
//	Departure DEP
	DEP = "DEP",
//	En-Route ENR
	ENR = "ENR",
//	Initial Approach Waypoint IAWP
	IAWP = "IAWP",
//	Initial Approach Fix IAF
	IAF = "IAF",
//	Intermediate Waypoint IWP
	IWP = "IWP",
//	Intermediate Fix IF
	IF = "IF",
//	Final Approach Waypoint FAWP
	FAWP = "FAWP",
//	Final Approach Fix FAF
	FAF = "FAF",
//	Landing Threshold Point LTP
	LTP = "LTP",
//	Missed Approach Waypoint MAWP (includes turning and holding waypoints)
	MAWP = "MAWP",
//	Missed Approach Point MAPt
	MAPt = "MAPt"
}

export enum EnumRoles{
  ROLE_READER = 'ROLE_READER',
  ROLE_WRITER = 'ROLE_WRITER'
}
export enum AntennaTypes{
  SECTORIAL_DIRECTIONAL = 'SECTORIAL/DIRECTIONAL',
  OMNIDIRECTIONAL = 'OMNIDIRECTIONAL'
}
export class ConfigurationConstants{


  public static LATITUDE_MAX : number = 90; // decimal degrees
	public static LATITUDE_MIN : number = -90; // decimal degrees

	public static LONGITUDE_MAX : number = 180; // decimal degrees
	public static LONGITUDE_MIN : number = -180; // decimal degrees
  public static COORDINATE_POINT_ID_LENGTH_MAX : number  = 5; // characters
	public static COORDINATE_POINT_ID_LENGTH_MIN : number = 1; // characters
  public static COORDINATE_POINT_MAX_DISTANCE_METERS_SAME_ID = 100; // meters

  protected static FIGURE_OF_MERIT_OUT_OF_SERVICE : number = -1;
	protected static FIGURE_OF_MERIT_NOT_CIVIL : number = -2;
  protected static FIGURE_OF_MERIT_BEYOND130: number = 500;
  
  public static readonly DOC_MIN = 1; //NM
  public static readonly DOC_MAX = 500; //NM
  public static readonly ALTITUDE_MAX = 60000.0; // feet
  public static readonly ALTITUDE_MIN = 0; // feet
  public static readonly ELEVATION_MAX_FT = 32767.0; // feet
  public static readonly ELEVATION_MIN_FT = -32768.0; // feet
  public static readonly ELEVATION_MAX_MT = 9987.3816; // meter
  public static readonly ELEVATION_MIN_MT = -9987.6864; // meter

  static getMaxDocArincFOM(fom : string): number{
    let value : number;
    switch(fom){
      case "TERMINAL_USE":
        value = 25;
        break;
      case "LOW_ALTITUDE_USE":
        value = 40;
        break;
      case "HIGH_ALTITUDE":
        value = 130;
        break;
      case "EXTENDED_HIGH_ALTITUDE":
        value = this.FIGURE_OF_MERIT_BEYOND130;
        break;
      case "OUT_OF_SERVICE":
        value = this.FIGURE_OF_MERIT_OUT_OF_SERVICE;
        break;
      default:
        value = 0;
        break;
    }
    return value;
  }
}
